import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  const navItems = [
    { to: '/', label: 'Home' },
    { to: '/support', label: 'Support' },
    { to: '/privacy', label: 'Privacy' }
  ];

  return (
    <nav className="apple-nav">
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex h-14 items-center justify-between">
          <Link to="/" onClick={closeMenu} className="flex items-center gap-2">
            <img src="/vizo-logo.png" alt="Vizo" className="h-7 w-7 rounded-lg" />
            <span className="text-sm font-semibold tracking-tight text-white">Vizo</span>
          </Link>

          <ul className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  onClick={closeMenu}
                  className={({ isActive }) =>
                    `rounded-full px-4 py-1.5 text-xs transition ${
                      isActive ? 'text-white' : 'text-white/60 hover:text-white'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>

          <a
            href="https://apps.apple.com/tr/app/vizo-music-visualizer/id6749325448"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden rounded-full bg-white px-4 py-1.5 text-xs font-semibold text-black transition hover:opacity-90 md:inline-flex"
          >
            Download
          </a>

          <button
            className="inline-flex h-9 w-9 items-center justify-center text-white md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className="sr-only">Menu</span>
            <div className="space-y-1.5">
              <span className={`block h-0.5 w-5 rounded bg-white transition ${isMenuOpen ? 'translate-y-2 rotate-45' : ''}`}></span>
              <span className={`block h-0.5 w-5 rounded bg-white transition ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-0.5 w-5 rounded bg-white transition ${isMenuOpen ? '-translate-y-2 -rotate-45' : ''}`}></span>
            </div>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="border-t border-white/10 bg-black px-6 py-4 md:hidden">
          <ul className="space-y-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  onClick={closeMenu}
                  className={({ isActive }) =>
                    `block rounded-lg px-4 py-2.5 text-sm transition ${
                      isActive ? 'bg-white/10 text-white' : 'text-white/60 hover:text-white'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
            <li>
              <a
                href="https://apps.apple.com/tr/app/vizo-music-visualizer/id6749325448"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 block rounded-full bg-white px-4 py-2.5 text-center text-sm font-semibold text-black"
                onClick={closeMenu}
              >
                Download
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
